import { Route } from "@/routes/routes.types";

/**
 * Create routes object where each route has its path and params
 */
export const routes = {
    dashboard: {
        path: "/dashboard",
    },
    helloWorld: {
        path: "/hello-world",
    },
} as const satisfies Record<string, Route>;

/**
 * Define Routes type representing all the defined routes
 */
export type Routes = typeof routes;

/**
 * Define RoutesPaths type union of all routes paths
 */
export type RoutesPaths = Routes[keyof Routes]["path"];
